import ArrowRightAlt from "@mui/icons-material/ArrowRightAlt";
import React from "react";
import { gridStyles } from "../GridStyles";
export default function HeaderCell(column) {
    const styles = gridStyles();
    if (column.canSort) {
        if (column.align == "right") {
            return (React.createElement(React.Fragment, null,
                React.createElement(ArrowRightAlt, { sx: (styles.sortIcon, column.isSorted ? (column.isSortedDesc ? styles.sortIconDesc : styles.sortIconAsc) : styles.sortIcon), className: `data-grid-sort-icon ${column.isSorted ? (column.isSortedDesc ? "desc" : "asc") : ""}` }),
                React.createElement("div", { style: { flexShrink: 1, overflow: "hidden", display: "flex" } }, column.render("Header"))));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { style: { flexShrink: 1, overflow: "hidden", display: "flex" } }, column.render("Header")),
                React.createElement(ArrowRightAlt, { sx: (styles.sortIcon, column.isSorted ? (column.isSortedDesc ? styles.sortIconDesc : styles.sortIconAsc) : styles.sortIcon), className: `data-grid-sort-icon ${column.isSorted ? (column.isSortedDesc ? "desc" : "asc") : ""}` })));
        }
    }
    else {
        return React.createElement(React.Fragment, null, column.render("Header"));
    }
}
